import { SentryFilter } from 'sentryFilters/types'

export const thirdPartyBugFilters: SentryFilter[] = [
  {
    name: 'third-party-error',
    description: 'Filter out third party errors by checking error message patterns',
    match: (event, hint) => {
      // Filter by error message patterns
      const errorMessage = (hint.originalException as Error)?.message || event.message || ''
      const thirdPartyPatterns = [/Cannot redefine property/i, /webauthn/i, /extension context/i]

      return thirdPartyPatterns.some(pattern => pattern.test(errorMessage))
    },
  },
  {
    name: 'fbq-error',
    description: 'Filter out fbq errors by checking error message patterns',
    match: (event, hint) => {
      // Filter by error message patterns
      const errorMessage = (hint.originalException as Error)?.message || event.message || ''
      return errorMessage.includes('fbq')
    },
  }
]
